module.exports = __webpack_public_path__ + "img/ico2_active.6e95699f.png";